export default class TextCarousel {

    constructor(elem, strings) {
        this.elements = {
            holder: elem
        }

        this.elements.value = this.elements.holder.querySelector('.js-text-value');

        this.strings = strings;

        this.settings = {
            delay: 5000
        }

        if(!this.elements.holder || !this.strings){return;}

        this.startCarousel();
   }

    startCarousel() {

        let i = 0;
        const self = this;

        function stringLoop() {
            setTimeout(function(){
                const string = self.strings[i];

                const transition = self.elements.holder.querySelector('.js-text-transition');

                if(transition) {
                    transition.style.width = ((self.elements.holder.offsetWidth / 10) + 2) + 'rem';
                    self.elements.holder.classList.add('is--anim');
                    transition.classList.add('anim--in');
                    transition.addEventListener('transitionend', () => {
                        self.elements.value.innerHTML = string;

                        if (transition.offsetWidth < self.elements.holder.offsetWidth){
                            transition.style.width = (self.elements.holder.offsetWidth / 10 + 2) + 'rem';
                        }
                        transition.classList.remove('anim--in');
                        self.elements.holder.classList.remove('is--anim');
                    });
                }


                // loop
                i = (i < (self.strings.length - 1)) ? i + 1 : 0;
                stringLoop();
            }, self.settings.delay);
        }

        stringLoop();
    }
}